import { Box, Button, Typography } from '@mui/material'
import { MdNavigateNext } from 'react-icons/md'
import { Link as RouterLink } from 'react-router-dom'
import { useIperiaStatus } from '../../hooks/useIperiaStatus'
import { nextLotPath, remainingUnsignedSiblings } from '../../utils/iperiaLot'

/**
 * Enchaîne sur l'inscription suivante du lot une fois le bulletin courant signé.
 *
 * Sans ce raccourci, l'apprenante doit retourner dans sa boîte mail chercher le lien du dossier
 * suivant, ce qui est le moment où un lot se perd. Le dossier proposé est choisi par le serveur
 * (`group.next_registration`) : les deux écrans qui offrent ce passage n'ont pas à trancher
 * eux-mêmes lequel des dossiers restants vient ensuite.
 *
 * Ne rend rien tant que le lot n'a plus rien à signer, ni pour un dossier isolé.
 */
const IperiaNextRegistrationButton = () => {
  const { status } = useIperiaStatus()
  const group = status?.group
  const next = group?.next_registration

  const path = nextLotPath(next)
  if (!group || !path) return null

  const remaining = remainingUnsignedSiblings(group)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>
        Il vous reste {remaining} formation{remaining > 1 ? 's' : ''} à signer
      </Typography>
      <Button
        variant="contained"
        component={RouterLink}
        to={path}
        endIcon={<MdNavigateNext />}
        sx={{ height: { xs: 45 }, width: { xs: '100%', sm: 'auto' } }}
      >
        Formation suivante
      </Button>
    </Box>
  )
}

export default IperiaNextRegistrationButton
